import { KeyRound } from 'lucide-react';
import AccessRequests from './AccessRequests';

export default function AccessRequestsPage({ user, selectedClient }) {
  const isStaff = ['super_admin', 'internal_team'].includes(user.role);
  const isViewingAsAdmin = selectedClient && user.role !== 'client';
  const firmId = isViewingAsAdmin ? selectedClient.firmId : (user.firm?.id || user.firm_id);

  if (!firmId) {
    return <div className="p-8 text-slate-400" data-testid="access-nofirm">Select a client to manage their access requests.</div>;
  }

  return (
    <div className="max-w-4xl animate-fadeInUp" data-testid="access-page">
      <div className="mb-6 flex items-center gap-3">
        <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center shadow-lg shadow-violet-500/30">
          <KeyRound className="w-5 h-5 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>Access</h1>
          <p className="text-sm text-slate-500">
            {isViewingAsAdmin ? `Manage ${selectedClient.name}'s platform access` : 'Grant your team the access they need to manage your platforms'}
          </p>
        </div>
      </div>

      <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-6 sm:p-8">
        <AccessRequests firmId={firmId} isStaff={isStaff} />
      </div>
    </div>
  );
}
